import { LoginRequest } from "@/models/entities/login-request.interface";
import { AuthState } from "@/models/utils/auth-state.interface";
import { ApiService } from "@zelando/vuelando";

const controller = "authenticate";

class AuthenticateService extends ApiService {
  constructor() {
    super(process.env.VUE_APP_API_ENDPOINT);
  }

  Login(credentials: LoginRequest) {
    return this.post<LoginRequest, AuthState>(
      `${controller}/login`,
      credentials
    );
  }

  CheckLogin() {
    return this.getAll<boolean>(`${controller}/status`);
  }

  Logout() {
    return this.getAll<void>(`${controller}/logout`);
  }
}

export const authenticate = new AuthenticateService();
